<template>
<div class="chapter">
<div class="inner_page">
<p class="ack-head"><b><i>Acknowledgments</i></b></p>
<p class="ack">So many people in my life have been supportive during my needlework journey, but none more than my mother, Doris, who put a needle in my hand when I was only a small girl and became my most devoted fan.</p>
<p class="ack">Big hugs for my husband, Frank, who hand dyed wool, made countless trips to the post office and airport, and never complained when the dining room looked more like a quilt studio.</p>
<p class="ack">My dear friend Helene cheerfully traveled with me to classes, shop hops, quilt shows, and embroidery seminars, sharing the fabrics and threads and always making it more fun.</p>
<p class="ack">I am grateful to my amazingly supportive sisters, Cindy, Carol, Janet, and Robin, who have oohed and aahed at every showing of my work since I was a teenager.</p>
<p class="ack">I must also recognize my lifelong friend and colleague Mari. Mari’s encouragement and support was unwavering as she held the fort at Gemini Studio. Many thanks!</p>
<p class="ack">I also wish to thank all my pilot students for reading directions, making excellent suggestions, and helping me become a better instructor.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_acknowledgments.vue?ae40d660